import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { Corner } from '@material/menu-surface';
import { MDCMenu } from '@material/menu';
import 'next/stylesheets/components/projects/todo-combo-filter';

Component('tr-todo-combo-filter', {
  mixins: [eventListenerMixin],

  properties: {
    filtered: {
      type: Boolean,
      default: false,
    },
    advance: {
      type: Boolean,
      default: false,
    },
    upgradeRequire: {
      type: Boolean,
      default: true,
    },
    openOnReady: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.quickFilter = this.querySelector('tr-project-todo-quick-filter');
    this.advanceFilter = this.querySelector('tr-project-todo-advance-filter');

    this.triggerButton = this.querySelector('.filter-toggle-button');
    if (!this.lazy) {
      this.listenTo(this.triggerButton, 'click', this.toggleFilterForm.bind(this));
    }
  },

  ready() {
    if (this.lazy) return;

    this.quickFilter.menu.setAnchorElement(this.triggerButton);
    this.quickFilter.menu.setAnchorCorner(Corner.BOTTOM_LEFT);
    this.listenTo(this.quickFilter, 'tr-project-todo-quick-filter:advanceSelected', this.handleAdvanceSelected.bind(this));

    if (this.advanceFilter) {
      this.advanceFilter.menu.setMenuSurfaceAnchorElement(this.triggerButton);
      this.advanceFilter.menu.setAnchorCorner(Corner.BOTTOM_LEFT);
    }

    if (this.openOnReady) {
      this.toggleFilterForm();
      this.openOnReady = false;
    }
  },

  handleAdvanceSelected(event) {
    event.stopPropagation();

    if (this.upgradeRequire) {
      if (!this.upgradeMenu) {
        this.upgradeMenu = new MDCMenu(this.querySelector('.mdc-menu--upgrade-required'));
        this.upgradeMenu.quickOpen = true;
        this.upgradeMenu.setAnchorElement(this.triggerButton);
        this.upgradeMenu.setAnchorCorner(Corner.BOTTOM_LEFT);
      }

      this.quickFilter.menu.open = false;
      this.upgradeMenu.open = true;
    } else if (this.advanceFilter) {
      this.quickFilter.menu.open = false;
      this.advanceFilter.menu.open = true;
    }
  },

  toggleFilterForm() {
    if (this.advance && this.advanceFilter) {
      this.advanceFilter.menu.open = !this.advanceFilter.menu.open;
    } else {
      this.quickFilter.menu.open = !this.quickFilter.menu.open;
    }
  },

  disconnected() {
    this.stopListening();
  },
});
